import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createHospitalAction,
  deleteHospitalAction,
  getHospitalAction,
  updateHospitalAction,
} from "../../Actions/HospitalAction/HospitalAction";
import Modal from "../../Modal/Modal";
import ToggleButton from "../../Buttons/ToggleButton";
import Input from "../../Buttons/Input";
import { getBranchAction } from "../../Actions/BranchAction/BranchAction";
import { FaTrash } from "react-icons/fa6";
import { FaRegEdit } from "react-icons/fa";
import Pagination from "../Pagination";
import DeleteModal from "../../Modal/DeleteModal";
import { CiFilter } from "react-icons/ci";

function Hospital() {
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState(null);
  useEffect(() => {
    dispatch(getHospitalAction(page, perPage, search));
  }, [perPage]);

  const handleSearch = (e) => {
    dispatch(getHospitalAction(page, perPage, search));
  };

  const { hospitals, total } = useSelector((state) => state.getHospital);
  useEffect(() => {
    dispatch(getBranchAction());
  }, []);

  const { branches } = useSelector((state) => state.getBranch);
  const branchOptions = branches.map((branch) => ({
    value: branch.id,
    label: branch.name,
  }));
  const [isChecked, setIsChecked] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(createHospitalAction(formData, isChecked));
  };
  const [formData, setFormData] = useState({
    name: "",
    branchId: "",
  });
  const [id, setId] = useState(null);

  const handleEdit = (id) => {
    setId(id);
    setOpenModal(true);
    const hospital = hospitals.find((hospital) => hospital.id === id);
    setFormData({
      name: hospital.name,
      branchId: {
        label: hospital.branch.name,
        value: hospital.branch.id,
      },
      isChecked: hospital.status,
    });
  };

  const handleClose = () => {
    setOpenModal(false);
    setId(null);
    setFormData({
      name: "",
      branchId: "",
    });
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    dispatch(updateHospitalAction(id, formData, isChecked));
    setOpenModal(false);
    setId(null);
    setFormData({
      name: "",
      branchId: "",
    });
  };
  const onPageChange = (event) => {
    setPage(event.selected);
    dispatch(getHospitalAction(event.selected, perPage, search));
  };
  const [openModal, setOpenModal] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const handleDelete = () => {
    dispatch(deleteHospitalAction(id));
  };
  return (
    <div
      className="bg-white w-11/12 mx-auto mt-3
      overflow-x-hidden
     p-3"
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4 w-full">
          <input
            type="text"
            placeholder="Search"
            className="border border-gray-300 rounded-md p-2 w-1/2"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <button
            onClick={handleSearch}
            className="bg-indigo-500 flex items-center gap-4 rounded-sm shadow-sm px-4 py-2 text-gray-100 hover:bg-transparent border-2 border-indigo-600 duration-500 hover:text-indigo-500"
          >
            <p className="font-bold">
              <CiFilter />
            </p>{" "}
            Search
          </button>
        </div>

        <div>
          <button
            onClick={() => setOpenModal(true)}
            className="bg-emerald-700/80 hover:bg-emerald-500 duration-200 text-gray-100 rounded-sm shadow-sm px-3 py-1 "
          >
            {" "}
            Add Hospital
          </button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full table-auto overflow-x-auto mt-3">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Branch</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {hospitals?.map((hospital, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{hospital?.name}</td>
                <td>{hospital?.branch?.name}</td>
                <td>
                  {hospital?.status === 1 ? (
                    <p className="text-green-600">Active</p>
                  ) : (
                    <p className="text-red-600">Inactive</p>
                  )}
                </td>
                <td>
                  <div className="flex gap-4">
                    <button
                      onClick={() => {
                        handleEdit(hospital.id);
                      }}
                      className="text-indigo-500 hover:text-indigo-600 duration-300 hover:underline flex gap-2 items-center"
                    >
                      <FaRegEdit />
                      Edit
                    </button>
                    <button
                      onClick={() => {
                        setIsOpenDeleteModal(true);
                        setId(hospital.id);
                      }}
                      className="text-red-500 hover:text-red-600 duration-300 hover:underline flex gap-2 items-center"
                    >
                      <div>
                        <FaTrash />
                      </div>
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {total > 0 ? (
        <Pagination
          total={total}
          page={page}
          perPage={perPage}
          setPerPage={setPerPage}
          onPageChange={onPageChange}
        />
      ) : (
        ""
      )}

      {openModal && (
        <Modal isOpen={openModal} closeModal={handleClose} width={"w-1/2"}>
          <div className=" bg-white">
            <button
              onClick={() => setOpenModal(false)}
              className="text-xl font-bold text-red-600 cursor-pointer"
            >
              X
            </button>

            <form action="" className="">
              <div className="grid grid-cols-2 gap-4">
                <Input
                  formData={formData}
                  setFormData={setFormData}
                  type={"text"}
                  name={"name"}
                  placeholder={"Name"}
                  label={"Name"}
                />
                <Input
                  formData={formData}
                  setFormData={setFormData}
                  type={"select"}
                  name={"branchId"}
                  placeholder={"Branch"}
                  label={"Branch"}
                  options={branchOptions}
                />

                <ToggleButton
                  isChecked={isChecked}
                  setIsChecked={setIsChecked}
                />
              </div>

              <button
                onClick={id ? handleUpdate : handleSubmit}
                className="bg-emerald-700/80 mt-3 text-gray-50 hover:bg-emerald-600 duration-500 rounded-sm shadow-sm px-3 py-1 "
              >
                {id ? "Update" : "Create"}
              </button>
            </form>
          </div>
        </Modal>
      )}

      {isOpenDeleteModal && (
        <DeleteModal
          onDelete={handleDelete}
          isOpen={isOpenDeleteModal}
          onClose={() => setIsOpenDeleteModal(false)}
        />
      )}
    </div>
  );
}

export default Hospital;
